import { RoleService } from '@/modules/global-settings/security/services/role.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

// Create a new service instance for each module
const roleService = new RoleService();

// Roles module state
export const state = {
  roles: []
};
// Roles module mutations
export const mutations = {
  ...make.mutations(state)
};

// Roles module actions
export const actions = {
  /**
   * Fetch all roles
   * @param {Object} Object - Vuex context
   * @returns {Array} Array of roles
   */
  fetchRoles: async ({ commit }) => {
    try {
      const { data } = await roleService.findAll('', '', {});
      commit('SET_ROLES', data);
      return data;
    } catch (error) {
      Logger.error('fetching roles');
      throw error;
    }
  },

  /**
   * Create a single role with the given data
   * @param {Object} Object - Vuex context
   * @param {Object} payload - Role data
   * @returns {Object} Created role
   */
  createRole: async ({ dispatch }, payload) => {
    try {
      const { data } = await roleService.create(payload);
      dispatch('fetchRoles');
      return data;
    } catch (error) {
      Logger.error('create role');
      throw error;
    }
  },

  /**
   * Update a single role with the given data
   * @param {Object} Object - Vuex context
   * @param {Object} payload - Role data
   * @param {string | number} payload.id - Role id
   *  @param {Object} payload.data - Role data
   * @returns {Object} Updated role
   */
  updateRole: async ({ dispatch }, { id, payload }) => {
    try {
      await roleService.update(id, payload);
      dispatch('fetchRoles');
    } catch (error) {
      Logger.error('updating role');
      throw error;
    }
  },

  /**
   * Delete a single role with the given id
   * @param {Object} Object - Vuex context
   * @param {string | number} id - Role id
   * @returns {void}
   */
  deleteRole: async ({ dispatch }, id) => {
    try {
      await roleService.delete(id);
      dispatch('fetchRoles');
    } catch (error) {
      Logger.error('deleting department');
      throw error;
    }
  }
};

// Roles module getters
export const getters = { 
  ...make.getters(state),

  getUserRole: (state) => (id) => state.roles.find( r => r.id == id) 
}
